import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200101Status: 'idle',
    startProcess200101Error: undefined as any,
    loadUserParamsProcess200101Status: 'idle',
    loadUserParamsProcess200101Error: undefined as any,

    process200101List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200101 = createAsyncThunk('process200101Slice/startProcess200101', async ({ process200101 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200101/`,
        prepareData(process200101),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200101Status } = getState().process200101Slice
        return startProcess200101Status !== 'pending'
    }
})

export const loadUserParamsProcess200101 = createAsyncThunk('process200101Slice/loadUserParamsProcess200101', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200101/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200101Status } = getState().process200101Slice
        return loadUserParamsProcess200101Status !== 'pending'
    }
})

const Process200101Slice = createSlice({
    name: 'process200101Slice',
    initialState,
    reducers: {
        resetstartProcess200101: (state) => {
            state.job = undefined
            state.startProcess200101Error = undefined
        },
        resetstartProcess200101Error: (state) => {
            state.startProcess200101Error = undefined
        },
        resetloadUserParamsProcess200101: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200101Error = undefined
        },
        resetloadUserParamsProcess200101Error: (state) => {
            state.loadUserParamsProcess200101Error = undefined
        },
        removeFromProcess200101ListById: (state, action) => {
            state.process200101List = state.process200101List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200101ListByIds: (state, action) => {
            state.process200101List = state.process200101List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200101List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200101Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200101List = []
            state.startProcess200101Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200101.pending, (state) => {
            state.startProcess200101Status = 'pending'
            state.startProcess200101Error = undefined
        })
        builder.addCase(startProcess200101.fulfilled, (state, action) => {
            state.startProcess200101Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200101.rejected, (state, action) => {
            state.startProcess200101Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200101Error = action.error.message
            } else {
                state.startProcess200101Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200101.pending, (state) => {
            state.loadUserParamsProcess200101Status = 'pending'
            state.loadUserParamsProcess200101Error = undefined
        })
        builder.addCase(loadUserParamsProcess200101.fulfilled, (state, action) => {
            state.loadUserParamsProcess200101Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200101.rejected, (state, action) => {
            state.loadUserParamsProcess200101Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200101Error = action.error.message
            } else {
                state.loadUserParamsProcess200101Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200101,
    resetstartProcess200101Error,
    resetloadUserParamsProcess200101,
    resetloadUserParamsProcess200101Error,
    removeFromProcess200101ListById,
    removeFromProcess200101ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200101Slice.actions
export default Process200101Slice.reducer
